// In the smallest currency unit (8 digits, $999,999.99). Stripe Elements throws on anything
// larger, which breaks the whole checkout.
export const STRIPE_MAX_AMOUNT = 99999999;

export function exceedsStripeMaxAmount(amount: number | null | undefined): boolean {
  return typeof amount === 'number' && amount > STRIPE_MAX_AMOUNT;
}
